import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/product/bundle'
// Modules
import numbers from './numbers'
import bundle from './bundle'

import {map} from 'lodash'

const initialState = () => ({
    bundles: {
        data: [],
        pagination: {}
    },
    allBundles: {
        data: [],
        pagination: {}
    },
    originatingBundles: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        bundles: state => map(state.bundles.data, bundle => ({
            ...bundle,
            bundle_id: `${bundle.id}_${bundle.type}`.toLowerCase()
        })),
        allBundles: state => map(state.allBundles.data, bundle => ({
            ...bundle,
            bundle_id: `${bundle.id}_${bundle.type}`.toLowerCase()
        })),
        originatingBundles: state => map(state.originatingBundles.data, bundle => ({
            ...bundle,
            bundle_id: `${bundle.id}_${bundle.type}`.toLowerCase()
        })),
        pagination: state => state.bundles.pagination
    },
    actions: {
        listBundles: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listBundles(data)
                const bundles = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_CUSTOMER_BUNDLES, bundles)
                return bundles
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        listAllBundles: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listBundles(data)
                const allBundles = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_CUSTOMER_ALL_BUNDLES, allBundles)
                return allBundles
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        listOriginatingBundles: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listBundles(data)
                const allBundles = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_CUSTOMER_ORIGINATING_BUNDLES, allBundles)
                return allBundles
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetBundles: ({commit}) => commit(mutationTypes.RESET_CUSTOMER_BUNDLES),
        resetAllBundles: ({commit}) => commit(mutationTypes.RESET_CUSTOMER_ALL_BUNDLES),
        resetOriginatingBundles: ({commit}) => commit(mutationTypes.RESET_CUSTOMER_ORIGINATING_BUNDLES)
    },
    modules: {
        numbers,
        bundle
    },
    mutations: {
        [mutationTypes.RESET_CUSTOMER_BUNDLES]: (state) => state.bundles = initialState().bundles,
        [mutationTypes.SET_CUSTOMER_BUNDLES]: (state, data) => state.bundles = data,
        [mutationTypes.RESET_CUSTOMER_ALL_BUNDLES]: (state) => state.allBundles = initialState().allBundles,
        [mutationTypes.SET_CUSTOMER_ALL_BUNDLES]: (state, data) => state.allBundles = data,
        [mutationTypes.RESET_CUSTOMER_ORIGINATING_BUNDLES]: (state) => state.originatingBundles = initialState().originatingBundles,
        [mutationTypes.SET_CUSTOMER_ORIGINATING_BUNDLES]: (state, data) => state.originatingBundles = data
    }
}
